import { useContext, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { AppContext } from "../AppProvider";
import "../../styles/sidebar_styles/CustomerAdministratorSideBar.css";
const CustomerAdministratorSideBar = () =>{
    const navigate = useNavigate();
    const {
        showSideBar,setShowSideBar,
        mobileSideBarLauncherRef
    } = useContext(AppContext);
    const customerAdministratorSideBarRef = useRef(null);
    const handleCustomerAdministratorSideBarClick = (e) =>{
        if(mobileSideBarLauncherRef.current && !mobileSideBarLauncherRef.current.contains(e.target) &&
            customerAdministratorSideBarRef.current && !mobileSideBarLauncherRef.current.classList.contains('hidden')){
                setShowSideBar(false);
        }
    };
    useEffect(() => {
        document.addEventListener('click',handleCustomerAdministratorSideBarClick);
    },[]);
    useEffect(() =>{
        if(!showSideBar && customerAdministratorSideBarRef.current && !customerAdministratorSideBarRef.current.classList.contains('hidden')){
            customerAdministratorSideBarRef.current.classList.add('hidden');
        }
        else if(showSideBar && customerAdministratorSideBarRef.current && customerAdministratorSideBarRef.current.classList.contains('hidden')){
            customerAdministratorSideBarRef.current.classList.remove('hidden');
        }
    },[showSideBar]);
    return (
        <div ref={customerAdministratorSideBarRef} className={`customer-administrator-side-bar ${showSideBar? 'show':''}`}>
            <div className="customer-administrator-side-bar-button-container" onClick={() => navigate('/')}>
                <img src={process.env.PUBLIC_URL + '/images/home-icon.png'} alt="."/>
                <button>Home</button>
            </div>
            <div className="customer-administrator-side-bar-button-container" onClick={() => navigate('/customers/admin/dashboards')}>
                <img src={process.env.PUBLIC_URL + '/images/dashboards-icon.png'} alt="."/>
                <button>Dashboards</button>
            </div>
            <div className="customer-administrator-side-bar-button-container" onClick={() => navigate('/customers/admin/devices')}>
                <img src={`${process.env.PUBLIC_URL}/images/devices-icon.png`} alt="Devices"/>
                <button>Devices</button>
            </div>
            <div className="customer-administrator-side-bar-button-container" onClick={() => navigate('/customers/admin/customers')}>
                <img src={`${process.env.PUBLIC_URL}/images/customers-icon.png`} alt="."/>
                <button>Customers</button>
            </div>
            <div className="customer-administrator-side-bar-button-container" onClick={() => navigate('/customers/admin/invoices')}>
                <img src={`${process.env.PUBLIC_URL}/images/invoices-icon.png`} alt="."/>
                <button>Invoices</button>
            </div>
    </div>);
}
export default CustomerAdministratorSideBar;